<template>
  <div class="content-wrapper">
    <header class="header">
      {{ $route.query.year }} yil uchun Xisobot malumotlari:
    </header>
    <el-button class="backTo" @click="$router.go(-1)">Orqaga</el-button>

    <el-table
      :data="tableData"
      class="main-table"
      :border="parentBorder"
      style="width: 100%"
    >
      <el-table-column type="expand">
        <template #default="props">
          <div m="4">
            <el-table :data="props.row.family" :border="childBorder">
              <el-table-column prop="title">
                <template #header>
                  <span style="color: #007791">Tuman byudjet hisobidan:</span>
                </template>
              </el-table-column>

              <el-table-column>
                <template #header>
                  <span style="color: #007791">Shakllangan:</span>
                </template>
                <template #default="scope">
                  <el-input :placeholder="scope.value" />
                </template>
              </el-table-column>

              <el-table-column>
                <template #header>
                  <span style="color: #007791">Reja (Ming so'm):</span>
                </template>
                <template #default="scope">
                  <el-input :placeholder="scope.value" />
                </template>
              </el-table-column>

              <el-table-column>
                <template #header>
                  <span style="color: #007791">Tolovchi hisob raqami:</span>
                </template>
                <template #default="scope">
                  <el-input :placeholder="scope.value" />
                </template>
              </el-table-column>

              <el-table-column>
                <template #header>
                  <span style="color: #007791">Oluvchi hisob raqami:</span>
                </template>
                <template #default="scope">
                  <el-input :placeholder="scope.value" />
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="region_title">
        <template #header>
          <span style="color: #007791">Xudud nomi:</span>
        </template>
      </el-table-column>
      <el-table-column prop="last_update">
        <template #header>
          <span style="color: #007791">Songi tahrirlangan sana:</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { ref } from "vue";

const parentBorder = ref(true);
const childBorder = ref(false);
const tableData = [
  {
    last_update: "2016-05-03",
    region_title: "California",
    family: [
      { value: 20000, title: "Tashkent" },
      { value: 20000, title: "Tashkent" },
      { value: 20000, title: "Tashkent" },
      { value: 20000, title: "Tashkent" },
      { value: 20000, title: "Tashkent" },
    ],
  },
  {
    last_update: "2016-05-03",
    region_title: "California",
    family: [
      { value: 20000, title: "Tashkent" },
      { value: 20000, title: "Tashkent" },
      { value: 20000, title: "Tashkent" },
      { value: 20000, title: "Tashkent" },
      { value: 20000, title: "Tashkent" },
    ],
  },
  {
    last_update: "2016-05-03",
    region_title: "California",
    family: [
      { value: 20000, title: "Tashkent" },
      { value: 20000, title: "Tashkent" },
      { value: 20000, title: "Tashkent" },
      { value: 20000, title: "Tashkent" },
      { value: 20000, title: "Tashkent" },
    ],
  },
];
</script>

<style scoped>
.content-wrapper {
  position: relative;
  height: 100%;
}
.header {
  text-align: center;
  font-weight: normal;
  position: relative;
  top: 30px;
}

.backTo {
  position: absolute;
  top: 0px;
  left: 5px;
}

.main-table {
  margin-top: 60px;
}
.primary {
  color: #007791;
}
</style>
